import CurrentOrganization from './CurrentOrganization'

export default CurrentOrganization



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/CurrentOrganization/index.js